export default {"src":"/_next/static/media/dift-small-black.c91321ba.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};